import React from 'react'

import { string } from 'prop-types'

import i18n from 'Pods/Shared/I18nHome'
import { modelsPath } from 'Pods/Shared/paths'

import PromoCard from './PromoCard'
import BookDiscountIcon from '../../Icons/BookDiscountIcon'
import FlowerDownloadIcon from '../../Icons/FlowerDownloadIcon'

function PromoCards({ freeItems = '', locale = 'en' }) {
  const onSaleTitle = i18n.t('modelFilters.promoCards.sale', { ns: 'new-home', lng: locale })
  const freeItemsTitle = i18n.t('modelFilters.promoCards.free', { ns: 'new-home', lng: locale })
  const browseAllButtonPath = modelsPath(locale)

  return (
    <div className="promo-cards">
      <PromoCard
        href={`${browseAllButtonPath}?sale_off=1`}
        variant="sale"
        icon={BookDiscountIcon}
        title={onSaleTitle}
      />
      <PromoCard
        href={`${browseAllButtonPath}?free=1`}
        variant="free"
        icon={FlowerDownloadIcon}
        title={freeItemsTitle}
        badge={freeItems}
      />
    </div>
  )
}

PromoCards.displayName = 'PromoCards'

PromoCards.propTypes = {
  freeItems: string,
  locale: string,
}

export default PromoCards
